/* This FaqTemplate requires Tailwind CSS v2.0+ */
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import MarkdownBlock from './Chat/MarkdownBlock';

export default function FaqTranscription() {
  const { t, lang } = useLocale('common');
  const { t: tTranscription } = useLocale('ai-transcription');

  const faqs = [
    {
      question: tTranscription('faq_transcription_q1'),
      answer: tTranscription('faq_transcription_a1'),
    },
    {
      question: tTranscription('faq_transcription_q2'),
      answer: tTranscription('faq_transcription_a2'),
    },
    {
      question: tTranscription('faq_transcription_q3'),
      answer: tTranscription('faq_transcription_a3'),
    },
    {
      question: tTranscription('faq_transcription_q4'),
      answer: tTranscription('faq_transcription_a4'),
    },
    {
      question: tTranscription('faq_transcription_q5'),
      answer: tTranscription('faq_transcription_a5'),
    },
    {
      question: tTranscription('faq_transcription_q6'),
      answer: tTranscription('faq_transcription_a6'),
    },
    {
      question: tTranscription('faq_transcription_q7'),
      answer: tTranscription('faq_transcription_a7'),
    },
    {
      question: tTranscription('faq_transcription_q8'),
      answer: tTranscription('faq_transcription_a8'),
    },
    {
      question: tTranscription('faq_transcription_q9'),
      answer: tTranscription('faq_transcription_a9'),
    },
    {
      question: tTranscription('faq_transcription_q10'),
      answer: tTranscription('faq_transcription_a10'),
    },
    {
      question: tTranscription('faq_transcription_q11'),
      answer: tTranscription('faq_transcription_a11'),
    },
    {
      question: tTranscription('faq_transcription_q12'),
      answer: tTranscription('faq_transcription_a12'),
    },
  ];

  return (
    <div className='bg-gray-50 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl py-12 px-4 sm:py-16 sm:px-6 lg:px-8'>
        <div
          className='mx-auto max-w-3xl divide-y-2 divide-gray-200 dark:divide-slate-600'
          itemScope
          itemType='https://schema.org/FAQPage'
        >
          <h2 className='text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-slate-200'>
            {t('Frequently asked questions')}
          </h2>
          <dl className='mt-6 space-y-6 divide-y divide-gray-200 dark:divide-slate-600'>
            {faqs.map((faq) => (
              <Disclosure
                as='div'
                key={faq.question}
                className='pt-6'
                itemScope
                itemProp='mainEntity'
                itemType='https://schema.org/Question'
              >
                {({ open }) => (
                  <>
                    <dt className='text-lg'>
                      <Disclosure.Button className='flex w-full items-start justify-between text-left text-gray-400 dark:text-slate-400'>
                        <span
                          className='font-medium text-gray-900 dark:text-slate-200'
                          itemProp='name'
                        >
                          {faq.question}
                        </span>
                        <span className='ml-6 flex h-7 items-center'>
                          <ChevronDownIcon
                            className={clsxm(
                              open ? '-rotate-180' : 'rotate-0',
                              'h-6 w-6 transform',
                            )}
                            aria-hidden='true'
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel
                      as='dd'
                      className='mt-2 pr-12'
                      itemScope
                      itemProp='acceptedAnswer'
                      unmount={false}
                      itemType='https://schema.org/Answer'
                    >
                      <div
                        className='text-base text-gray-500 dark:text-slate-400'
                        itemProp='text'
                      >
                        <MarkdownBlock
                          message={faq.answer.replace(/\n/g, '  \n')}
                        />
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
